import { SupplierEvaluations } from "./equipment/SupplierEvaluations";

export const SupplierEvaluationsTab = () => {
  return <SupplierEvaluations />;
};